import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import localSitemapData from "./sitemap.json";
import "./Sitemap.css";

export default function Sitemap() {
  const [sitemapData, setSitemapData] = useState([]);
  const [importantLinks, setImportantLinks] = useState(null);

  useEffect(() => {
    const fetchSitemapData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_SITEMAP_LIST);
        setSitemapData(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchSitemapData();
  }, []);

  useEffect(() => {
    const fetchImportantLinks = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_CDN}angelai-life/jsons/sitemap.json`);
        setImportantLinks(response.data);
      } catch (error) {
        console.error('Error fetching important links from CDN, using local fallback:', error);
        setImportantLinks(localSitemapData);
      }
    };
    fetchImportantLinks();
  }, []);

  // Get specific sections in desired order
  const getFilteredData = () => {
    if (!sitemapData || sitemapData.length === 0) return null;
    const column2 = sitemapData.find(item => item.Column2);
    const lists = column2?.Column2?.Lists || [];
    
    const events = lists.find(section => section.heading === "Events");
    const angelAiLifeMortgage = lists.find(section => section.heading === "AngelAi.Life (Mortgage Loan Officers)");
    
    return [importantLinks, events, angelAiLifeMortgage].filter(Boolean);
  };

  const filteredSections = getFilteredData();

  const renderSection = (section) => {
    if (!section) return null;
    
    // Sort loan officers alphabetically
    const sortedList = section.heading === "AngelAi.Life (Mortgage Loan Officers)" 
      ? [...(section.List || [])].sort((a, b) => a.name.localeCompare(b.name))
      : section.List || [];
    
    // Auto-detect scrolling need based on list length (more than 10 items)
    const needsScrolling = sortedList.length > 10;
    
    return (
      <div key={section.heading} style={{ marginBottom: '2rem' }}>
        <div className="d-flex align-items-center pb-2 heading-border">
          <div className="orange-head-box"></div>
          <h5 className="sitemap-section-head">{section.heading}</h5>
        </div>
        <ul className={`custom-list ${needsScrolling ? "scrollable-list" : ""}`}>
          {sortedList.map((item) => (
            <li key={item.id}>
              <a href={item.url} target="_blank" rel="noreferrer">
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div>
      <div className="sitemap-banner">
        <Container>
          <Row>
            <Col>
              <h1>AngelAi.Life Site Map</h1>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="154"
                height="25"
                viewBox="0 0 254 25"
                fill="none"
              >
                <path
                  d="M1 22.4712C34.8333 9.13791 132.7 -11.2288 253.5 13.9712"
                  stroke="#FF541C"
                  strokeWidth="4"
                />
              </svg>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="sitemap-container mb-5">
        <Row className="sitemap-row">
          <Col sm={12} md={4} className="sitemap-col">
            <div style={{ marginBottom: '2rem' }}>
              <div className="d-flex align-items-center pb-2 heading-border">
                <div className="orange-head-box"></div>
                <h5 className="sitemap-section-head">AngelAi.Life</h5>
              </div>
              <ul className="custom-list">
                <li>
                  <a href="https://angelai.life" target="_blank" rel="noreferrer">
                    angelai.life
                  </a>
                </li>
              </ul>
            </div>
            {filteredSections && filteredSections[0] && renderSection(filteredSections[0])}
          </Col>
          <Col sm={12} md={4} className="sitemap-col">
            {filteredSections && filteredSections[1] && renderSection(filteredSections[1])}
          </Col>
          <Col sm={12} md={4} className="sitemap-col">
            {filteredSections && filteredSections[2] && renderSection(filteredSections[2])}
          </Col>
        </Row>
      </Container>
    </div>
  );
}